import useAbortController from '@hook/useAbortController'
import { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { fetchGet, fetchProxy } from '@lib/fetch/client'
import { useTranslations } from 'next-intl'
import { getFilterOptions } from './lib'

const CombineContext = createContext()

export function useCombine() {
  return useContext(CombineContext)
}

export function CombineProvider({ children }) {
  const [keyword, setKeyword] = useState('')

  const { getSignal } = useAbortController()
  const ts = useTranslations('search')
  const ta = useTranslations('agent')
  const [options, setOptions] = useState([])
  const [loading, setLoading] = useState(false)

  // 获取搜索列表
  const getOptions = useCallback((key, optionPrevFilter) => {
    const { signal } = getSignal()

    // https://7thave.atlassian.net/browse/HT-4141?focusedCommentId=17112
    const param = { keyword: key }
    // https://7thave.atlassian.net/browse/HT-4944
    // if(type === houseSearchType.estimate) {
    //   param.listingsOnly = true
    // }

    setKeyword(key)
    key && fetchProxy(
      fetchGet('property-search-combine', param, { signal }),
      setLoading
    ).then((data) => {
      const tmp = optionPrevFilter(data)
      setOptions(getFilterOptions(tmp, ts, ta))
    })
  }, [getSignal, ta, ts])

  const config = useMemo(() => ({
    keyword,
    options,
    loading,
    getOptions,
    setKeyword,
  }), [getOptions, keyword, loading, options])

  return (
    <CombineContext.Provider value={config}>
      {children}
    </CombineContext.Provider>
  )
}
